/**
 * HVN: Dashboard block registration.
 *
 * Presentation layer only. Mounts the EXISTING Agent Workspace SPA (via the
 * existing [hvnly_agent_dashboard] shortcode pipeline) — it adds no dashboard
 * logic, data, permissions or routing of its own.
 *
 * @package
 * @since   3.5.0
 */

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './edit';
import icon from '../shared/icon';

registerBlockType( metadata.name, {
	icon,
	edit: Edit,
	save: () => null,
} );
